import React from "react";
import {
  Accordion,
  DoubleContent,
  LinkPrimary,
  SectionContent,
  TextBodyAccordion,
} from "../../../../components";
import { links } from "../../../../config";
import DuvidasSobreContemplacaoStyle from "./DuvidasSobreContemplacao.Style";

const leftDuvidasAccordion = [
  {
    title: "Fui contemplado por lance. O que preciso fazer?",
    body: (
      <>
        <TextBodyAccordion>
          A partir da data da assembleia em que foi contemplado, você deve, em
          até 5 dias úteis, entrar em contato por telefone para confirmar a sua
          contemplação e receber o boleto para pagamento do lance. Após este
          prazo, você perderá o direito à contemplação, por isso, não deixe para
          última hora.
        </TextBodyAccordion>
        <TextBodyAccordion>
          Central de Serviços e Relacionamento:{" "}
          <LinkPrimary href="tel:08002741000" label="0800 274 1000" /> das 8h
          às 21h, de segunda a sexta, exceto em feriados nacionais.
        </TextBodyAccordion>
        <TextBodyAccordion>
          Lembre-se: é importante manter seus dados sempre atualizados para
          receber nossas comunicações.
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "O que posso fazer com o meu crédito?",
    body: (
      <TextBodyAccordion>
        <LinkPrimary href={links.consorcio.entendaSobreConsorcio}>
          Confira aqui
        </LinkPrimary>{" "}
        algumas possibilidades para utilizar o seu crédito.
      </TextBodyAccordion>
    ),
  },
];

const rightDuvidasAccordion = [
  {
    title: "Onde solicito o uso do meu crédito?",
    body: (
      <TextBodyAccordion>
        Você pode solicitar o uso do crédito pela{" "}
        <LinkPrimary href={links.consorcio.areaLogada} target="_blank">
          área do cliente
        </LinkPrimary>
        . Ah! Lembre-se de ler a cartilha com atenção e reunir os documentos
        necessários.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Posso converter meu crédito em dinheiro?",
    body: (
      <TextBodyAccordion>
        Sim. Caso decida não utilizar seu crédito, após 180 dias da
        contemplação, você poderá convertê-lo em dinheiro e, para isso, deverá
        pagar todo o seu saldo restante.
      </TextBodyAccordion>
    ),
  },
];

const DuvidasSobreContemplacao = () => {
  return (
    <DuvidasSobreContemplacaoStyle as={SectionContent}>
      <DoubleContent
        leftContent={<Accordion listItems={leftDuvidasAccordion} />}
        rightContent={<Accordion listItems={rightDuvidasAccordion} />}
      />
    </DuvidasSobreContemplacaoStyle>
  );
};

export default DuvidasSobreContemplacao;
